var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPlaceLocator = function SvgIcPlaceLocator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.636 10.215c0 6.248-7.636 11.603-7.636 11.603s-7.637-5.355-7.637-11.603c0-2.13.805-4.174 2.237-5.68C8.032 3.028 9.974 2.182 12 2.182c2.025 0 3.967.846 5.4 2.353 1.431 1.506 2.236 3.55 2.236 5.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 12.892c1.405 0 2.545-1.198 2.545-2.677 0-1.48-1.14-2.678-2.545-2.678-1.406 0-2.546 1.199-2.546 2.678 0 1.479 1.14 2.677 2.546 2.677Z"
  })));
};
export default SvgIcPlaceLocator;